export default __webpack_public_path__ + "static/media/screen_google_calendar_11.7da67140.png";